<mat-sidenav-container [hasBackdrop]="false">
  <mat-sidenav mode="side" [opened]="sidebarOpen">
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="page">
      <mat-toolbar>
        <app-topbar class="w-full" [sidebarOpen]="sidebarOpen" (toggleFullScreenSidebar)="sidebarOpen = !sidebarOpen">
        </app-topbar>
      </mat-toolbar>
      <div class="page__content">
        <router-outlet class="appContainer"></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
